import openWindow from '@/script/openWindow.mjs'
import metaBizNode from '../../metaBizNode.mjs'
import extendNode from '../extendNode.mjs'
import useCategoryRootNode from '../_CATEGORY_ROOT/useCategoryRootNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootPrj.jsx'
import meta from './metaCatRootPrj.mjs'

const productTypes = Object.values(metaBizNode)
    .filter(
        ({classes}) => (
            classes.includes('product') &&
            ! classes.includes('arch')
        )
    )
    .map(({type}) => type)

export default () => {
    const CategoryRootNode = useCategoryRootNode()

    return extendNode(CategoryRootNode, {
        ...meta,
        PropertiesPane,

        canMountType(map, node, type) {
            const {pblType} = map.data

            if ('INCREMENT' === pblType) {
                return productTypes.includes(type)
            }
            else {
                return /^([ABCFOPU]A|CAT_(DATA|DB|DEP|DOC|LS|MD|RULEM|SS))$/.test(type)
            }
        },

        canLinkType(map, node, type) {
            const {pblType} = map.data

            if ('INCREMENT' === pblType) {
                return map.BizNode.AR.canLinkType.call(this, map, node, type)
            }
            else {
                return false
            }
        },

        async gotoCurrent(map, node, target) {
            const {prjId, sVer} = node.data
            openWindow('/SaList', {prjId, sVer}, target)
        },

        menuItemsInsertCommon(map, node) {
            const {pblType} = map.data

            if ('INCREMENT' === pblType) {
                return [
                    {type: 'AR'},
                ]
            }
            else {
                return []
            }
        },

        menuItemsInsertProduct(map, node) {
            const {pblType} = map.data

            if ('INCREMENT' === pblType) {
                return map.BizNode.AR.menuItemsInsertProduct.call(
                    this, map, node
                )
            }
            else {
                return []
            }
        },

        async onEvent(map, node, event) {
            if (! /^(attach|change|create|delete|insert)$/.test(event.type)) {
                return
            }

            const Src2Dst = {
                CAT_DB: 'DEP_DB',
                SS_MID: 'DEP_MID',
                SS_SS: 'DEP_SS',
            }

            const [src, bizNodeType] = (() => {
                for (const n of event.chain) {
                    const {bizNodeType} = n.data
                    const dstType = Src2Dst[bizNodeType]

                    if (dstType) {
                        return [n, dstType]
                    }
                }

                return []
            })()

            if (! src) {
                return
            }

            const [dst] = map.queryNodes({algo: 'bfs', data: {bizNodeType}})

            if (! dst) {
                return
            }

            const _s = map.nodeProxy(src)
            const {children} = _s.exportTree({compact: true})
            const _d = map.nodeProxy(dst)
            _d.replace({children})
            await _d.shrink()
        },
    })
}
